import React from "react"
import { useStaticQuery, graphql, navigate } from "gatsby"

import Banner from "components/ui/Banner"
import ImageWrapper from "components/ui/ImageWrapper"
import BottomIllustration from "assets/svgs/bottom-illustration.svg"
import Button from "components/ui/Button"

import * as Styled from "./styles"

import { LandingPageType } from "types/enums"
import { LandingPagesProps, SectionBanner } from "types/interfaces"
import { useCalendly } from "hooks/useCalendly"
import { CalendlyPopup } from "components/CalendlyPopup"

const BottomBanner: React.FC<LandingPagesProps> = ({ landingType }) => {
  const { isCalendlyPopupOpen, setCalendlyPopupOpen } = useCalendly()
  const { markdownRemark } = useStaticQuery(graphql`
    query {
      markdownRemark(frontmatter: { category: { eq: "bottom section" } }) {
        frontmatter {
          title
          linkTo
          linkText
        }
      }
    }
  `)

  const bottomBanner: SectionBanner = markdownRemark.frontmatter
  const getStartedButtonLabel =
    landingType === LandingPageType.MANAGEMENT_COMPANIES
      ? "Request a demo"
      : "Get started"

  const onGetStartedButtonClick = () => {
    if (landingType === LandingPageType.MANAGEMENT_COMPANIES) {
      return setCalendlyPopupOpen(true)
    }

    navigate(`${process.env.GATSBY_APP_BASE_URL}/auth/signup`)
  }

  return (
    <Styled.Wrapper>
      <CalendlyPopup
        isOpen={isCalendlyPopupOpen}
        onClose={() => setCalendlyPopupOpen(false)}
      />
      <Styled.ContentWrapper>
        <Styled.Box>
          <Banner
            title={{ title: bottomBanner.title, bottom: true }}
            subtitle={{ subtitle: "" }}
            textContent={{ textContent: "" }}
          />
          <Button
            activeShadow={true}
            landingType={landingType}
            primary
            shadow
            onClick={onGetStartedButtonClick}
          >
            {getStartedButtonLabel}
          </Button>
        </Styled.Box>
        <Styled.Box>
          <ImageWrapper>
            <BottomIllustration />
          </ImageWrapper>
        </Styled.Box>
      </Styled.ContentWrapper>
    </Styled.Wrapper>
  )
}

export default BottomBanner
